<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ submission.stringID }} - {{ submission.customerName }}
            </h1>
            <p class="log_info">
              Created by {{ submission.customerName }} on {{ dateFormatWithTime(submission.createdAt) }} <br>Last updated on {{ dateFormatWithTime(submission.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-1"
        style="margin-bottom: 20px !important;"
        md="6"
      >
        <b-card
          class="has-padding h-100 body-padding-zero"
          style="margin: 0 !important;"
        >
          <b-card-title class="mb-2">
            Purchaser Details
          </b-card-title>
          <b-card-body class="p-0">
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-none d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    Purchaser Name
                  </b-th>
                  <b-td>{{ submission.customerName ? submission.customerName : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    NRIC
                  </b-th>
                  <b-td>{{ submission.customerNric ? submission.customerNric : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Date of Birth
                  </b-th>
                  <b-td>{{ submission.customerDob ? dateFormat(submission.customerDob) : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Sex
                  </b-th>
                  <b-td>{{ submission.customerSex ? submission.customerSex : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Race
                  </b-th>
                  <b-td>{{ submission.customerRace ? submission.customerRace : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Nationality
                  </b-th>
                  <b-td>{{ submission.customerNationality ? submission.customerNationality : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Mobile No.
                  </b-th>
                  <b-td>{{ submission.customerContact ? submission.customerContact : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Email Address
                  </b-th>
                  <b-td>{{ submission.customerEmail ? submission.customerEmail : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Permanent Address
                  </b-th>
                  <b-td>{{ getPermanentAddress(submission) }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Correspondence Address
                  </b-th>
                  <b-td>{{ getCorrespondenceAddress(submission) }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        class="content-header-left mb-1"
        style="margin-bottom: 20px !important;"
        md="6"
      >
        <b-card
          class="has-padding h-100 body-padding-zero"
          style="margin: 0 !important;"
        >
          <b-card-title class="mb-2">
            Order Item Details
          </b-card-title>
          <b-card-body>
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-none d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    Product Type
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.productType || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Zone No.
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.zoneNo || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Lot No.
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.lotNo || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Lot Type
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.lotType || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Bury Capacity
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.buryCapacity || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Area Length
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.size || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Direction
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.direction || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Side
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.side || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Level No.
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.levelNo || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Section No.
                  </b-th>
                  <b-td>{{ submission.lot ? (submission.lot.section || '–') : '–' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Earliest Interment Date
                  </b-th>
                  <b-td>
                    Immediate
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Need Type
                  </b-th>
                  <b-td>{{ submission.needType ? submission.needType : '–' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card
      title="Attachments"
      class="mb-3 mt-3 p-2"
    >
      <b-row v-if="attachments.length">
        <!-- Content Left -->
        <b-col
          v-for="(file, key) in attachments"
          :key="key"
          class="content-header-left mb-2"
          cols="12"
          md="4"
        >
          <div
            class="attachment-item"
          >
            <b-img
              v-if="file.type.includes('image')"
              left
              height="40"
              :src="require('@/assets/images/admin/doc_jpg.png')"
              alt="Left image"
            />
            <b-img
              v-if="file.type.includes('application')"
              left
              height="40"
              :src="require('@/assets/images/admin/doc_file.png')"
              alt="Left image"
            />
            <strong>
              <b-link
                v-if="file.fileStorage"
                :to="{ name: 'file-view', params: { id: file.fileStorage } }"
                target="_blank"
              >
                {{ file ? file.name : '' }}
              </b-link>
              <b-link
                v-else-if="file.data"
                :href="file ? file.data : ''"
                target="_blank"
              >
                {{ file ? file.name : '' }}
              </b-link>
            </strong>
            <span>{{ file ? `${file.size}mb` : '' }}</span>
          </div>
          <div class="doc__desc new_design">
            <span v-if="file.description">
              {{ file.description }}
            </span>
            <span v-else>
              <button
                @click="updateDescription(key)"
              >
                Add a description
              </button>
            </span>
            <span
              v-if="file.description"
              class="edit__desc"
            >
              <b-button
                variant="flat-primary"
                @click="updateDescription(key)"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                  size="18"
                />
              </b-button>
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <div class="empty_block">
            <h4>Nothing in here yet</h4>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-attachment-description"
      size="lg"
      title="Attachment Description"
      modal-class="status-update-modal"
      centered
      no-stacking
      header-class="front-modal"
      @ok="saveDescription"
      @cancel="closeDescriptionModal"
    >
      <b-row>
        <b-col md="12">
          <b-form-textarea
            id="h-customer-phone-number"
            v-model="description"
            placeholder="E.g. Payment Schedule"
          />
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="!description || attachmentKey === ''"
          @click="ok()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardBody, BCardTitle, BRow, BCol, BTableSimple, BTbody, BTr, BTd, BTh, BImg, BFormTextarea,
  BButton, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BCardBody,
    BCardTitle,
    BRow,
    BCol,
    BTableSimple,
    BTbody,
    BTh,
    BTr,
    BTd,
    BImg,
    BFormTextarea,
    BLink,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      submission: {},
      status: 'published',
      statusValidation: false,
      statusError: 'Valid status is required',
      statusDataOptions: [
        { title: 'Published', code: 'published' },
        { title: 'Draft', code: 'draft' },
      ],
      attachments: [],
      attachmentKey: '',
      description: '',
      required,
    }
  },
  created() {
    this.$http.get(`sales/sales-submission/changi/${this.$route.params.id}`)
      .then(response => {
        this.submission = response.data
        this.attachments = this.submission.attachments.filter(file => file.fileStorage)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    getPermanentAddress(submission) {
      let permanentAddress = ''
      permanentAddress += submission.perAddress1 ? submission.perAddress1 : ''
      permanentAddress += submission.perAddress2 ? `, ${submission.perAddress2}` : ''
      permanentAddress += submission.perCountry ? `, ${submission.perCountry}` : ''
      permanentAddress += submission.perPostcode ? ` ${submission.perPostcode}` : ''
      return permanentAddress
    },
    getCorrespondenceAddress(submission) {
      let correspondenceAddress = ''
      correspondenceAddress += submission.corAddress1 ? submission.corAddress1 : ''
      correspondenceAddress += submission.corAddress2 ? `, ${submission.corAddress2}` : ''
      correspondenceAddress += submission.corCountry ? `, ${submission.corCountry}` : ''
      correspondenceAddress += submission.perPostcode ? ` ${submission.perPostcode}` : ''
      return correspondenceAddress
    },
    closeDescriptionModal() {
      this.$root.$emit('bv::hide::modal', 'modal-attachment-description', '')
    },
    updateDescription(key) {
      this.attachmentKey = key
      this.description = this.attachments[key].description
      this.$root.$emit('bv::show::modal', 'modal-attachment-description', '')
    },
    saveDescription() {
      const id = this.attachments[this.attachmentKey]._id
      this.$http
        .post('sales/sales-submission/changi/attachment/save-description', { id, description: this.description, submissionID: this.submission._id })
        .then(response => {
          this.attachments = response.data.data.attachments.filter(file => file.fileStorage)
          this.closeDescriptionModal()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
  .item-field-custom-class {
    color: #000000;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }
  .display-content {
    display: contents;
  }

  .custom-th-width {
    .table th {
        padding: 0.72rem 2rem 0.72rem 0.72rem;
    }
  }
</style>
